import { RecordLink } from '../../record-link/record-link';
import { remove, each, filter } from 'lodash';
import { GroupItem } from './group-item';
import { DossierTree, VisitFn } from './tree';
import { sortAlphabetically } from '../../utils';

const sortByLabelFn = sortAlphabetically('label');


export type ItemType = 'ROOT' | 'SIMPLE' | 'SIMPLE_WITH_GROUPS' | 'GROUP' | 'RECORD' | 'DATA';

export type TreeItemCheckedType = 'YES' | 'NO' | 'INDETERMINATE' | 'DISABLED';

export interface TreeItemWithRecord {
  link: RecordLink
}

export abstract class TreeItem {

  protected tree: DossierTree

  parent: TreeItem;
  children: TreeItem[] = [];
  closed: boolean = false;
  checked: TreeItemCheckedType = 'NO';

  selectedGroup: GroupItem = null

  constructor(parent: TreeItem, tree: DossierTree) {
    this.parent = parent;
    this.tree = tree;
  }

  abstract get type(): ItemType
  abstract get label(): string

  addChild(item: TreeItem) {
    this.children.push(item);
  }

  removeChild(item: TreeItem) {
    remove(this.children, child => child === item);
  }

  get selected(): boolean {
    return this.tree.isLinkSelected(this);
  }

  get groups(): GroupItem[] {
    return [];
  }

  get isNew(): boolean {
    return false;
  }

  get isReadOnly(): boolean {
    return this.tree.dossier.is_archived;
  }

  toggleExpand(): any { }

  get canExpand() {
    return this.groups.length > 0 && this.selectedGroup;
  }

  get realGroups(): GroupItem[] {
    // Ignore groups marked as New
    return filter(this.groups, g => !g.isNew);
  }

  get groupsCount() {
    return this.realGroups.length;
  }

  get hasGroups(): boolean {
    return this.groupsCount > 0;
  }

  get canRetract() {
    return this.hasGroups && !this.selectedGroup;
  }

  get canSelect() {
    let type = this.type;
    return type === 'ROOT' || type === 'GROUP' || type === 'RECORD' || type === 'DATA';
  }

  get canMoveGroupUp() {
    return false;
  }

  get canMoveGroupDown() {
    return false;
  }

  protected static sortByLabel(a: TreeItem, b: TreeItem): number {
    return sortByLabelFn(a, b);
  }

  visit(fn: VisitFn) {
    fn(this);

    each(this.children, child => child.visit(fn));
  }

  toggleChecked(newValue: TreeItemCheckedType = null) {
    if(newValue) {
      this.checked = newValue;
    }
    else {
      if(this.checked === 'NO') {
        this.toggleChecked('YES');
      }
      else {
        this.toggleChecked('NO');
      }
    }
  }
}